import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';

@Component({
  selector: 'app-price-min-max-form',
  templateUrl: './price-min-max-form.component.html',
  styleUrls: ['./price-min-max-form.component.scss']
})
export class PriceMinMaxFormComponent implements OnInit {

  _min: number;
  get min(): number {
    return this._min;
  }
  @Input() set min(value: number) {
    this._min = value;
    if (this.priceForm != null) {
      this.priceForm.get('min').setValue(value);
    }
  }

  _max: number;
  get max(): number {
    return this._min;
  }
  @Input() set max(value: number) {
    this._max = value;
    if (this.priceForm != null) {
      this.priceForm.get('max').setValue(value);
    }
  }

  @Output()
  applyChange = new EventEmitter<{ min: number, max: number }>();


  priceForm: FormGroup;

  constructor(
    private fb: FormBuilder
  ) {
    this.setupForm();
  }

  ngOnInit(): void {
  }

  setupForm() {
    this.priceForm = this.fb.group({
      min: [],
      max: []
    });
  }

  apply() {
    const source = this.priceForm.value;
    this.applyChange.emit(source);
  }

}
